import isEmail from 'validator/lib/isEmail';
import isURL from 'validator/lib/isURL';

const validation = (form) => {
  const errors = {};

  if (!form.email) {
    errors.email = 'We will contact you by this email address'
  } else if (!isEmail(form.email)) {
    errors.email = 'This email is not valid :('
  }

  if (!form.subject) {
    errors.subject = 'Choose which info you’d like to require'
  }

  if (form.subject === 'potential_partner' && !form.site) {
    errors.site = 'Please, write down your website'
  } else if (form.subject === 'potential_partner' && form.site && !isURL(form.site)) {
    errors.site = 'This link is incorrect :('
  }

  if (!form.text) {
    errors.text = 'Please, leave your comments'
  }

  if (!form.recaptchaResponse) {
    errors.recaptchaResponse = 'We hope, you’re not a robot. Please, verify'
  }

  return errors;
};

export { validation };